// Textos del listado de promos PVP (pvp-promos). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    PVP_PROMOS: {
      BREADCRUMB_ARIA: 'Ruta de navegació',
      BREADCRUMB_MARKETING: 'Màrqueting',
      BREADCRUMB_PROMO: 'Promo PVP',
      TITLE: 'Bonificació preu complet',
      DESCRIPTION:
        "Usuaris als quals s'ha activat la promo PVP. En completar 2 viatges verificats de més de 10 km a PVP, se'ls ingressa l'import a la cartera automàticament.",
      SEARCH_PLACEHOLDER: 'Cerca nom, correu o telèfon…',
      SEARCH_ARIA: 'Cerca usuari',
      STATUS_ARIA: 'Estat',
      STATUS_ALL: 'Estat: tots',
      STATUS_ACTIVE: 'En curs',
      STATUS_COMPLETED: 'Completada',
      STATUS_CANCELLED: 'Cancel·lada',
      FILTER_COMPLETED: 'Completades',
      FILTER_CANCELLED: 'Cancel·lades',
      CLEAR_FILTERS: 'Neteja els filtres',
      ACTIVATE: 'Activar promo',
      LOADING: 'Carregant promocions…',
      RETRY: 'Torna-ho a provar',
      EMPTY_FILTERED: 'Cap promoció coincideix amb la cerca.',
      EMPTY:
        "Encara no s'ha activat cap promoció. Activa-la amb «Activar promo» o des de la fitxa de l'usuari.",
      TH_USER: 'Usuari',
      TH_AMOUNT: 'Import',
      TH_ACTIVATED_BY: 'Activada per',
      TH_DATE: 'Data',
      TH_PROGRESS: 'Progrés',
      TH_STATUS: 'Estat',
      OPEN: 'Obre',
      PROGRESS_TITLE: '{{done}} de {{required}} viatges',
      DEPOSITED_ON: 'Ingressada el {{date}}',
      CANCELLED_BY: 'Cancel·lada per {{name}} el {{date}}',
      VIEW_PROFILE: 'Veure fitxa',
      SHOWING: 'Mostrant',
      OF: 'de',
      PROMOS: 'promocions',
      PER_PAGE_LABEL: 'Promocions per pàgina',
      PER_PAGE_OPTION: '{{n}} per pàgina',
      PREV_PAGE: 'Pàgina anterior',
      NEXT_PAGE: 'Pàgina següent',
      PREV: 'Anterior',
      NEXT: 'Següent',
      ERROR_FORBIDDEN: 'No tens permís per veure aquest llistat.',
      ERROR_LOAD: "No s'ha pogut carregar el llistat.",
    },
  },
};
